<template>
  <div class="gfr-container">
    <slot />
  </div>
</template>
<script lang="ts" setup></script>
<style lang="scss" scoped>
.gfr-container {
  @apply mx-auto h-full w-full pl-[70px] pr-17;
}
</style>
